import { useEffect, useState } from "react";
import { Bell, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

import { api } from "@/lib/api";

export default function ReminderBanner({ refreshKey = 0 }) {
  const [reminders, setReminders] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/me/followed-events")
      .then((response) => {
        const upcoming = response.data.filter((event) => event.days_until_deadline !== null && event.days_until_deadline >= 0);
        setReminders(upcoming);
      })
      .catch(() => setReminders([]))
      .finally(() => setLoaded(true));
  }, [refreshKey]);

  if (!loaded || !reminders.length) return null;
  const urgent = reminders.filter((event) => event.days_until_deadline <= 7);
  const primary = urgent[0] || reminders[0];

  return (
    <Link to="/calendar" className="reminder-banner" data-testid="reminder-banner">
      <div className="reminder-icon-wrap">
        <Bell size={20} />
        {urgent.length > 0 && <span className="reminder-pulse" />}
      </div>
      <div className="reminder-body">
        <b>
          {reminders.length === 1
            ? "1 EVENT MIT ANSTEHENDEM MELDESCHLUSS"
            : `${reminders.length} EVENTS MIT ANSTEHENDEM MELDESCHLUSS`}
        </b>
        <span>
          Nächster: <b>{primary.name}</b> · {formatDeadline(primary.days_until_deadline)}
        </span>
      </div>
      <ChevronRight size={22} />
    </Link>
  );
}

function formatDeadline(days) {
  if (days === 0) return "Meldeschluss HEUTE";
  if (days === 1) return "Meldeschluss MORGEN";
  if (days <= 7) return `nur noch ${days} Tage`;
  return `in ${days} Tagen`;
}
